import { render, staticRenderFns } from "./ativos-inativos.vue?vue&type=template&id=34f62afe&scoped=true&"
import script from "./ativos-inativos.vue?vue&type=script&lang=js&"
export * from "./ativos-inativos.vue?vue&type=script&lang=js&"
import style0 from "./ativos-inativos.vue?vue&type=style&index=0&id=34f62afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f62afe",
  null
  
)

export default component.exports